import { Skeleton } from "../skeleton";
import { ChatListSkeleton } from "./ChatListSkeleton";
import { cn } from "../../utils/cn";

export function ChatWindowSkeleton() {
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-2 sm:p-4 md:p-6">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-slate-900/40  backdrop-blur-sm" />

      {/* Modal Container */}
      <div
        className={cn(
          "relative w-full max-w-6xl h-[80vh] sm:h-[82vh]",
          "bg-white ",
          "rounded-xl sm:rounded-2xl shadow-2xl",
          "flex overflow-hidden",
          "border border-slate-200/60 ",
        )}
      >
        {/* Left: Chat Area */}
        <div className="flex-1 flex flex-col min-w-0 bg-white ">
          {/* Header Skeleton */}
          <div className="h-16 px-4 sm:px-6 border-b border-slate-100  flex items-center justify-between shrink-0 bg-white/80  backdrop-blur-md z-10">
            <div className="flex items-center gap-3">
              <Skeleton className="w-10 h-10 rounded-xl" />
              <div className="flex flex-col gap-1.5">
                <Skeleton className="w-24 h-4 rounded-md" />
                <Skeleton className="w-16 h-3 rounded-md" />
              </div>
            </div>
            <div className="flex items-center gap-2">
              <Skeleton className="w-8 h-8 rounded-lg" />
              <Skeleton className="w-8 h-8 rounded-lg" />
            </div>
          </div>

          {/* Chat Messages Skeleton */}
          <div className="flex-1 bg-slate-50/50  p-3 sm:p-6 overflow-hidden relative">
            <ChatListSkeleton count={4} />
          </div>

          {/* Input Skeleton */}
          <div className="p-4 bg-white  border-t border-slate-100  shrink-0">
            <div className="relative">
              <Skeleton className="w-full h-12 rounded-xl" />
            </div>
          </div>
        </div>

        {/* Right: Info Panel Skeleton (Hidden on mobile) */}
        <div className="hidden lg:flex w-[320px] border-l border-slate-100  bg-slate-50/50  flex-col">
          {/* Info Header */}
          <div className="p-5 border-b border-slate-100  bg-white ">
            <Skeleton className="w-20 h-5 mb-4 rounded-md" />
            <div className="flex items-center gap-3">
              <Skeleton className="w-12 h-12 rounded-xl" />
              <div className="flex flex-col gap-2">
                <Skeleton className="w-24 h-4 rounded-md" />
                <Skeleton className="w-16 h-3 rounded-md" />
              </div>
            </div>
          </div>

          {/* Info Content */}
          <div className="p-5 flex-1 flex flex-col gap-4">
            <Skeleton className="w-24 h-5 rounded-md" />
            <div className="flex-1 rounded-xl border border-slate-200/50  p-4 space-y-3">
              <Skeleton className="w-full h-4 rounded-md" />
              <Skeleton className="w-3/4 h-4 rounded-md" />
              <Skeleton className="w-5/6 h-4 rounded-md" />
            </div>
            <Skeleton className="w-full h-16 rounded-xl" />
          </div>
        </div>
      </div>
    </div>
  );
}
